export default __webpack_public_path__ + "static/media/DCA_224x224.084ef858.jpg";